
import FindPartner from "../../components/landing/search-on-social-media-and-mobile-chat/find-partner";
import QuotesBlock from "../../components/landing/search-on-social-media-and-mobile-chat/quotes-block";
import ServiceFor from "../../components/landing/search-on-social-media-and-mobile-chat/service-for";
import blog from "../../components/landing/blog";
import HowWeDo from "../../components/landing/search-on-social-media-and-mobile-chat/how-we-do";
import SitesScan from "../../components/landing/search-on-social-media-and-mobile-chat/sites-scan";
import Waiting from "../../components/landing/search-on-social-media-and-mobile-chat/waiting";
import Results from "../../components/landing/search-on-social-media-and-mobile-chat/results";
import Steps from "../../components/landing/search-on-social-media-and-mobile-chat/steps";
import RealStories from "../../components/landing/search-on-social-media-and-mobile-chat/real-stories.vue";
import Featured from "../../components/landing/search-on-social-media-and-mobile-chat/featured";
import Mission from "../../components/landing/search-on-social-media-and-mobile-chat/mission";
import AlreadyUsing from "../../components/landing/search-on-social-media-and-mobile-chat/already-using";
import Comments from "../../components/landing/search-on-social-media-and-mobile-chat/comments.vue";
import Overcoming from "../../components/landing/search-on-social-media-and-mobile-chat/overcoming";
import Faq from "../../components/landing/search-on-social-media-and-mobile-chat/faq";
import QuotesBlockKnowledge from "../../components/landing/search-on-social-media-and-mobile-chat/quotes-block-knowledge";
import Navigation from '../../components/Navigation.vue';
import FooterMain from '../../components/FooterMain.vue';

import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";

export default {
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    QuotesBlock,
    ServiceFor,
    HowWeDo,
    SitesScan,
    Waiting,
    Results,
    blog,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },
  head() {
    const title = 'Catch Your Cheating Spouse , Wife & Partner on Social Media | How To Catch A Cheater On Social Media';
    const description = 'Click to catch a cheating spouse, husband, wife, boyfriend, or unfaithful partner on Social Media. We also help to catch cheaters texting on mobile Chat. 100% Anonymous Service!';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { hid:'og:title', property: 'og:title', content: title },
        { hid: "description", name: "description", content: description },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'how to catch a cheater, how to catch cheating spouse, how to catch a cheating partner, catch a cheater, catch cheating spouse, catch a cheating partner, free cheater apps, catch cheating partners, how to catch your cheating spouse, how to catch a cheating spouse, free cheating spouse app'
        },
        { hid: "og:description", name: "og:description", content: description },
        { hid: 'og:image',  property: 'og:image', content: '/products/find-someone-cheating-online-for-free/og.png' },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid:'og:site_name', property: 'og:site_name', content: 'ifindcheaters.com' },
        { hid: 'og:keywords', name: 'og:keywords', content: 'secret profile finder, search people on dating sites, search for someone on dating sites, search dating profiles, is my husband on dating sites, find hidden dating profiles, find my wife on dating sites, catch a cheating spouse, find spouse on dating sites, Catch cheating partner online, Online infidelity search, find out if my boyfriend or girlfriend is on dating sites, how to find spouse on dating sites, is my wife on dating sites or apps, free dating profiles search by email' }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/search-on-social-media-and-mobile-chat/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Catching a cheating spouse on social media and mobile chat"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Catching a cheating spouse on social media and mobile chat",
            "sku": "003",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": "Click to catch a cheating wife, boyfriend, or unfaithful partner on Social Media. We also help to catch cheaters texting on mobile Chat. 100% Anonymous Service!",
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/search-on-social-media-and-mobile-chat/",
              "priceCurrency": "USD",
              "price": "9.99",
              "priceValidUntil": "2022-05-25",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Jennifer N."
              },
              "datePublished": "2022-08-05T14:08:30+00:00",
              "reviewBody": "I was tired of my all-time-being in smartphone boyfriend. And from the lie, which he told me about that. About work, games and others. After using the service everything became clear"
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4.5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Jessica1144"
              },
            "datePublished": "2020-10-09T15:35:29+00:00",
            "reviewBody": "Glad I used this site, got the info I needed. best website to find cheaters"
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.6",
              "reviewCount": "71"
              }
            }
          }
      ]
    }
  },
};
